import { useSettings } from "@/lib/SettingsContext";

export const Marquee = () => {
  const CONTENT = useSettings();
  const ITEMS = CONTENT.marquee || [];
  return (
    <div
      className="py-6 bg-white border-y border-slate-200 overflow-hidden select-none"
      data-testid="marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
            {ITEMS.map((item) => (
              <span key={item} className="flex items-center">
                <span className="mx-8 text-sm sm:text-base font-semibold uppercase tracking-[0.15em] text-amber-500/80">
                  {item}
                </span>
                <span className="text-amber-500/40 text-xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
